module.exports = __webpack_public_path__ + "img/face-kiss-beam.fd5fb08c.svg";